<div class="engagement-container">
  <progress-indicator></progress-indicator>
  <div
    class="padding-bottom-s padding-top-xs sticy-container sticky-element-after-black-header"
  >
    <div class="d-flex justify-content-between">
      <h4 class="eclipse-main-tab-header text-align-left">
        <span> {{ submissionDetails?.submissionTitle }}</span>
      </h4>
      <div class="button-container">
        <dds-button
          *ngIf="
            permissionObj['GLOBAL_ENG_SubmitButton_Visible'] &&
            isSubmissionStatusDraft()
          "
          class="custom-button margin-right-m"
          [theme]="primaryLoudButton.theme"
          [kind]="primaryLoudButton.kind"
          [size]="htmlElementSize"
          [width]="primaryLoudButton.width"
          [disabled]="isArchiveBtnDisabled()"
          ariaLabel="Archive and complete"
          (click)="archiveAndComplete()"
          >Archive and complete
        </dds-button>
      </div>
    </div>
    <div class="d-flex">
      <div
        class="submission-type font-size-12 font-bold-600 item-type margin-right-xs"
      >
        {{ submissionType }}
      </div>
      <div
        [style.color]="
          transformStatusStyle(submissionStatus) | statusStyle : 'color'
        "
        [style.backgroundColor]="
          transformStatusStyle(submissionStatus)
            | statusStyle : 'backgroundColor'
        "
        class="custom-pad margin-left-minus-xxs font-size-12 font-bold-600 margin-right-s"
      >
        {{ submissionStatus }}
      </div>
      <div
        class="id-container eclipse-content margin-left-minus-xs margin-top-xxxs"
      >
        <ng-container>
          <span class="id-title">ID:</span>
          <span #textToCopy class="eclipse-content"
            >{{ submissionDetails?.submissionId }}
          </span>
          <span
            class="dds-icon dds-icon_copy__l__stroke icon"
            (click)="copyToClipboard(textToCopy.textContent)"
          ></span>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="margin-top-m margin-right-m margin-bottom-m">
    <dds-accordion [isMulti]="true">
      <dds-accordion-item [isOpen]="true">
        <span header class="accordion-header">
          <div class="section-header">
            <span class="eclipse-section-header">Submission details</span>
          </div>
        </span>

        <span class="text-align-left" [autosave-module]="savedetails" content>
          <div
            *ngIf="
              permissionObj[
                'GLOBAL_ENG_SubmissionDetails_SubmissionTitle_Visible'
              ]
            "
            class="edit-title margin-bottom-m"
          >
            <div class="eclipse-small-header-grey text-align-left">
              <span *ngIf="!engagementTitle">
                <img
                  class="margin-right-xxs"
                  src="\assets\images\draftIcon.svg"
                  alt="yellow-icon" /></span
              >Submission title:
            </div>
            <div *ngIf="isEngagementTitleEditable; else displayTitle">
              <dds-textarea
                autosave
                [(ngModel)]="engagementTitle"
                [disabled]="
                  !permissionObj[
                    'GLOBAL_ENG_SubmissionDetails_SubmissionTitle_Enable'
                  ]
                "
              ></dds-textarea>
            </div>
            <ng-template #displayTitle>
              <span class="font-size-14">{{
                engagementTitle ?? defaultValue
              }}</span>
              <span
                #editButton
                *ngIf="
                  permissionObj[
                    'GLOBAL_ENG_SubmissionDetails_SubmissionTitle_Enable'
                  ] && isSubmissionStatusDraft()
                "
                (click)="makeFieldEditable('engagementTitle')"
                class="dds-icon dds-icon_edit__s__filled edit-icon"
              ></span>
            </ng-template>
          </div>
          <div
            *ngIf="
              permissionObj['GLOBAL_ENG_SubmissionDetails_ChangeCode_Visible']
            "
          >
            <app-global-engagement-wbs
              [permissionObj]="permissionObj"
              [submissionData]="submissionDetails ?? null"
              [isSubmissionStatusDraft]="isSubmissionStatusDraft()"
              (wbsOrArchiveChange)="wbsOrArchiveChange($event)"
              (isWbsArchiveEditProgress)="wbsArchiveEditProgress($event)"
            ></app-global-engagement-wbs>
            <div class="margin-top-s margin-bottom-m">
              <div class="eclipse-small-header-grey text-align-left">
                <span *ngIf="!efaSelected && isEfaEditable">
                  <img
                    class="margin-right-xxs"
                    src="\assets\images\draftIcon.svg"
                    alt="yellow-icon" /></span
                >EFA:
              </div>
              <div
                class="edit-title wbsWidth"
                *ngIf="
                  isEfaEditable && isSubmissionStatusDraft();
                  else displayEFA
                "
              >
                <div class="col-12 padding-top-xs">
                  <div class="search-box">
                    <dds-search
                      [size]="searchOptions.size ?? _BLANK"
                      [customClass]="searchOptions.customClass ?? _BLANK"
                      [icon]="searchOptions.icon || 'dds-icon_search'"
                      (fieldCleared)="fieldEfaCleared()"
                    >
                      <input
                        ddsSearch
                        [placeholder]="searchOptions.placeholder ?? _BLANK"
                        [(ngModel)]="efaSelected"
                        (ngModelChange)="findEfa($event)"
                      />
                    </dds-search>
                    <div
                      *ngIf="isEfaSpinnerVisible"
                      class="spinner-inside-input absolute"
                    >
                      <dds-spinner
                        [size]="spinnerOptions.size ?? _BLANK"
                        [theme]="spinnerOptions.theme ?? _BLANK"
                        [customClass]="spinnerOptions.customClass ?? _BLANK"
                        [isInverse]="spinnerOptions.isInverse ?? false"
                        [thickness]="spinnerOptions.thickness ?? _BLANK"
                      ></dds-spinner>
                    </div>
                  </div>
                  <div
                    *ngIf="showEfaDropdown"
                    class="list-of-oppportunities d-flex flex-column padding-xs margin-top-xs absolute box-shadow-xs col-8"
                    (scroll)="fetchMoreEfaResult($event)"
                  >
                    <div *ngIf="efaArr.length > 0; else noEfaFound">
                      <div *ngFor="let item of efaArr">
                        <div
                          class="opportunity-items d-flex flex-column"
                          (click)="onEfaSelect(item)"
                        >
                          <div class="opportunity-details text-align-left">
                            <span class="opportunity-details-name">
                              {{ item.name }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ng-template #noEfaFound>
                      <div class="no-users-found">
                        {{ efaNotFound }}
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <ng-template #displayEFA>
                <span class="font-size-14">{{
                  efaSelected ?? defaultValue
                }}</span>
                <span
                  *ngIf="isSubmissionStatusDraft()"
                  #editButton
                  (click)="makeFieldEditable('efa')"
                  class="dds-icon dds-icon_edit__s__filled edit-icon"
                ></span>
              </ng-template>
            </div>
          </div>
        </span>
      </dds-accordion-item>
      <dds-accordion-item [isOpen]="true">
        <span header class="accordion-header">
          <div class="section-header">
            <span class="eclipse-section-header">Documents</span>
          </div>
        </span>
        <span content>
          <app-engagement-documents
            [submissionId]="submissionId"
            [submissionTypeId]="submissionTypeId"
            [permissionObj]="permissionObj"
            [isSubmissionStatusDraft]="isSubmissionStatusDraft()"
            (documentTableData)="getAllUploadedDocuments($event)"
          ></app-engagement-documents>
        </span>
      </dds-accordion-item>
      <dds-accordion-item [isOpen]="true">
        <span header class="accordion-header">
          <div class="section-header">
            <span class="eclipse-section-header">Notes</span>
          </div>
        </span>
        <span [autosave-module]="savedetails" content>
          <div class="accordion-content">
            <div
              class="text-align-left eclipse-content-grey margin-top-s margin-bottom-s"
            >
              Use this field to provide notes about any relevant history,
              unusual aspects, or unique characteristics of the engagement.
            </div>
            <span
              *ngIf="checkStatusDiscontinued() && showDiscontinueMessage"
              class="padding-bottom-m text-align-left"
            >
              <div class="sub-text-section margin-top-xs">
                <span class="icon-s icon-alert"></span>
                <span>
                  <div class="eclipse-header-grey">Submission Discontinued</div>
                  <div
                    class="vertical-line-green-s absolute padding-bottom-xxs"
                    *ngIf="isShowMoreDocumentNotes"
                  ></div>
                </span>
              </div>
              <div class="padding-left-m">
                <span>
                  <div class="margin-top-xs" *ngIf="isShowMoreDocumentNotes">
                    <div
                      class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                    >
                      {{ discontinueActionMessage?.resetedOn }} by
                      {{ discontinueActionMessage?.resetedBy }}
                    </div>
                    <div
                      class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                    >
                      Reason: {{ discontinueActionMessage?.reason }}
                    </div>
                  </div>
                </span>
                <dds-button
                  class="showMoreCls"
                  [theme]="showMoreOptions.theme ?? ''"
                  [kind]="showMoreOptions.kind ?? ''"
                  [size]="showMoreOptions.size ?? ''"
                  [width]="showMoreOptions.width ?? ''"
                  [icon]="showMoreOptions.icon ?? ''"
                  [isIconLeft]="showMoreOptions.isIconLeft ?? false"
                  [role]="showMoreOptions.role ?? ''"
                  [ariaLabel]="showMoreText"
                  [customClass]="showMoreOptions.customClass ?? ''"
                  (clicked)="clickToShowDocumentMoreLepMessage()"
                  >{{ showMoreText }}</dds-button
                >
              </div>
            </span>
            <span
              *ngIf="showResetActionMessage"
              class="padding-bottom-m text-align-left"
            >
              <div>
                <span>
                  <div class="margin-top-xs">
                    <div>
                      <div
                        class="eclipse-content-grey font-size-11 padding-bottom-xxs"
                      >
                        <div>
                          Submission reset from
                          {{ resetActionMessage?.previousStatus }} to
                          {{ resetActionMessage?.currentStatus }} on
                          {{ resetActionMessage?.resetedOn }} by
                          {{ resetActionMessage?.resetedBy }}.
                        </div>
                        <div>
                          <span>Reason: {{ resetActionMessage?.reason }}</span>
                          <span
                            *ngIf="resetActionMessage?.otherReasonDescription"
                            class="padding-left-xs"
                            >{{
                              resetActionMessage?.otherReasonDescription
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div></span
                >
              </div>
            </span>
            <div>
              <div class="row margin-bottom-s">
                <div class="col-12">
                  <div class="textarea-container">
                    <div class="row">
                      <div class="col-12">
                        <dds-textarea
                          autosave
                          [(ngModel)]="notes"
                          [maxLength]="5000"
                          [maxLengthPosition]="'top-right'"
                          name="notesAndFeedback"
                          [disabled]="!isSubmissionStatusDraft()"
                        ></dds-textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </dds-accordion-item>
    </dds-accordion>
  </div>
</div>
